module.exports = __webpack_public_path__ + "img/c08_unitfireship_Normal_ua.3aad714c.webp";